module.exports = "https://i-jinbaozheng-network-website.oss-cn-shanghai.aliyuncs.com//img/qd-wushiling-manifesto.6aa5e8cf.png";